///<reference path="skyward.base.global.ts"/>
(
    function (skyward, $, undefined)
    {
        "use strict";
        skyward.calculatedFieldBuilder = skyward.calculatedFieldBuilder || {};

        // accepts args = { fieldName: string (optional),
        //                  expression: string(optional),
        //                  module: string(used for rooting the treebrowse),
        //                  object: string(used for rooting the treebrowse),
        //                  relationshipPath: string(used to prepend detail sections field names appropriately),
        //                  prompts: (required) Prompts Model so the cfBuilder can ask it to convert bindings to friendly names, and what prompts to present the user with
        //                  usedInExistsFilter: (required) if the calculated field is used in an exists condition
        //                  callback: function}
        skyward.calculatedFieldBuilder.launch = function (args)
        {
            let calculatedFieldBuilder;
            const promptsModel = args.prompts;
            if (!promptsModel || typeof promptsModel.toJsonObject !== 'function')
            {
                return;
            }
            const promptsJson = promptsModel.toJsonString();

            if (!args.fieldName) { args.fieldName = ''; }
            if (!args.expression) { args.expression = ''; }
            // accepts jsonResult = { html: html }
            var showPopup = function (jsonResult)
            {
                let popup;
                let nameValidationMessage;
                let nameLabel;
                let nameInput;
                let calculationValidationMessage;
                let calculationLabel;
                let calculationInput;

                var onSave = function ()
                {
                    const name = (nameInput.val() || "").trim(" ");
                    const nameIsBlank = !(name.length > 0);
                    const nameHasChanged = (args.fieldName != name);
                    const nameExists = nameHasChanged && skyward.reporting.calculatedFields.NameExists(name);
                    const nameIsNumeric = skyward.extensions.isNumeric(name);
                    const nameIsDangerous = skyward.extensions.containsHtml(name);
                    const nameIsNullLiteral = (name.toLowerCase() === "null");

                    const calculation = promptsModel.ConvertFriendlyNamesToPromptBindings(calculationInput.val());
                    const calculationIsBlank = !(calculation.length > 0);
                    const decodedCalculation = skyward.extensions.decodeHtml(calculation);
                    const calculationIsDangerous = decodedCalculation !== calculation;

                    let nameErrors = [];
                    if (nameIsBlank)
                    {
                        nameErrors.push("Name is a required field.");
                    }
                    if (nameExists)
                    {
                        nameErrors.push("This name is already in use.");
                    }
                    if (nameIsNumeric)
                    {
                        nameErrors.push("Name cannot be a number.");
                    }
                    if (nameIsDangerous)
                    {
                        nameErrors.push("Name contains invalid characters.");
                    }
                    if (nameIsNullLiteral)
                    {
                        nameErrors.push("Name cannot be 'null'.");
                    }

                    let calculationErrors = [];
                    if (calculationIsBlank)
                    {
                        calculationErrors.push("Calculation is a required field");
                    }
                    if (calculationIsDangerous)
                    {
                        calculationErrors.push("Calculation contains invalid characters.");

                        let indexOfFirstInvalidCharacter = 0;
                        while (calculation[indexOfFirstInvalidCharacter] === decodedCalculation[indexOfFirstInvalidCharacter])
                        {
                            indexOfFirstInvalidCharacter++;
                        }

                        if (indexOfFirstInvalidCharacter >= 0)
                        {
                            calculationInput.prop({ selectionStart: indexOfFirstInvalidCharacter, selectionEnd: indexOfFirstInvalidCharacter + 1 });
                        }
                        calculationInput.focus();
                    }

                    let errors = {};
                    const hasNameErrors = nameErrors.length > 0;
                    const hasCalculationErrors = calculationErrors.length > 0;
                    if (hasNameErrors)
                    {
                        errors["CustomFieldName"] = nameErrors;
                    }

                    if (hasCalculationErrors)
                    {
                        errors["CalculationInput"] = calculationErrors;

                    }

                    if (hasNameErrors || hasCalculationErrors)
                    {
                        skyward.validation.displayValidationMessages({ errors: errors }, calculatedFieldBuilder, $());
                        return;
                    }

                    nameInput.removeClass("error-control");
                    nameLabel.removeClass("error-text");
                    nameValidationMessage.hide();

                    calculationInput.removeClass("error-control");
                    calculationLabel.removeClass("error-text");
                    calculationValidationMessage.hide();

                    $.ajax(skyward.global.virtualDir + "Common/CalculatedFieldBuilder/GetOperation",
                        {
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                expression: skyward.extensions.decodeHtml(promptsModel.ConvertFriendlyNamesToPromptBindings(calculationInput.val())),
                                id: args.id,
                                schemaObject: args.schemaObject,
                                relationshipPath: args.relationshipPath,
                                currentPrompts: skyward.reporting.prompts.promptCollection.toJsonString()
                            }
                        }).done(function (data)
                        {
                            if (!data.syntaxError)
                            {
                                data.fieldName = nameInput.val();
                                data.schemaObject = args.schemaObject;
                                data.relationshipPath = args.relationshipPath;
                                data.parameters = JSON.parse(data.parameters);
                                args.callback(data);
                                popup.close();
                            }
                            else
                            {
                                const selectInvalidToken = function ()
                                {
                                    if (data.position != undefined)
                                    {
                                        calculationInput.prop({ selectionStart: data.position, selectionEnd: data.position + data.length });
                                    }
                                    calculationInput.focus();
                                };
                                skyward.modalLayer.showDialog("Syntax Error", data.syntaxError, { text: "Ok", click: "close", icon: "Check" }, { afterClose: selectInvalidToken });
                            }
                        });
                };


                const buttons = [
                    { text: "Save", click: onSave, icon: "Save", additionalClasses: "calculatedFieldBuilderSaveButton" },
                    { text: "Cancel", click: "close", icon: "Cancel" }
                ];
                popup = skyward.modalLayer.showDialog("Calculated Field Builder", jsonResult.html, buttons,
                    {
                        closeOnClick: false,
                        automationID: "calculated-field-dialog",
                        width: "100%"
                    });
                popup.bodyPromise.done(function ()
                {
                    calculatedFieldBuilder = popup.content;
                    nameInput = calculatedFieldBuilder.find(".customFieldName");
                    nameLabel = calculatedFieldBuilder.find(".calculatedFieldNameLabel");
                    nameValidationMessage = calculatedFieldBuilder.find(".calculatedFieldNameMessage");
                    calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    calculationInput.val(promptsModel.ConvertPromptBindingsToFriendlyNames(calculationInput.val()));
                    calculationValidationMessage = calculatedFieldBuilder.find(".calculationValidationMessage");
                    calculationLabel = calculatedFieldBuilder.find(".calculationLabel");

                    calculatedFieldBuilder.find(".operatorButton, .functionButton, .promptButton, .envVarButton").on("dblclick", addOperator);
                    calculatedFieldBuilder.find(".cfbTab").on("click", function ()
                    {
                        const tab = $(this);
                        if (tab.hasClass("active"))
                        {
                            return;
                        }

                        calculatedFieldBuilder.find(".leftTabLabels .cfbTab.active").removeClass("active");
                        calculatedFieldBuilder.find(".leftTabbed:not(.hidden)").addClass("hidden");

                        tab.addClass("active");
                        calculatedFieldBuilder.find("." + tab.data().relatedDiv).removeClass("hidden");
                    });

                    let areafields = skyward.reporting.fields.buildFieldListByModuleAndObject(args.schemaObject, args.relationshipPath, true, true);
                    const panelData =
                        [{
                            selector: ".js-usedFieldsPanel",
                            fields: areafields,
                            buildFieldPath: true
                        }];
                    skyward.fieldselectionpanels.initializePanels(calculatedFieldBuilder, panelData, addFieldFromFieldPanel, null);

                    (nameInput.val() != "" ? calculationInput : nameInput).attr('autofocus', true).focus();
                });
            };

                $.ajax(skyward.global.virtualDir + "Common/CalculatedFieldBuilder/GetPopup",
                    {
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            fieldName: args.fieldName,
                            expression: skyward.extensions.decodeHtml(args.expression),
                            schemaObject: args.schemaObject,
                            relationshipPath: args.relationshipPath,
                            prompts: promptsJson,
                            usedInExistsFilter: args.usedInExistsFilter
                        }
                    }).done(showPopup);

                var addFieldFromFieldPanel = function (event, fieldData)
                {
                    const fullFieldName = fieldData === undefined ? undefined : fieldData.absoluteFieldPath;
                    const calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    skyward.global.text.insertTextToken(calculationInput, "{" + fullFieldName + "}", true);
                };

                var addOperator = function ()
                {
                    const operatorButton = $(this);
                    const calculationInput = calculatedFieldBuilder.find(".calculatedFieldTextArea");
                    skyward.global.text.insertTextToken(calculationInput, promptsModel.ConvertPromptBindingsToFriendlyNames(operatorButton.data().token), true);
                };
            };
        }(window.skyward = window.skyward || {}, window.jQuery)
);